import PropTypes from "prop-types"

export default function LinkWithLabel({ url, className, icon, label }) {
  return (
    url && (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`${className} ${url ? `text-[#337ab7]` : "cursor-default hover:!no-underline"} `}
      >
        {icon}
        <span className="pl-2">{label}</span>
      </a>
    )
  )
}

LinkWithLabel.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.node,
  label: PropTypes.string,
}
